import React from 'react';

const DashboardTab = ({ incidents, isLoading }) => {
  // Calculate metrics from incidents state
  const totalIncidents = incidents.length;
  const openIncidents = incidents.filter(
    inc => inc.status !== 'resolved' && inc.status !== 'closed'
  ).length;

  const highSeverityIncidents = incidents.filter(inc =>
    ['high', 'critical'].includes(inc.severity)
  ).length;

  const safetyScore = totalIncidents > 0
    ? Math.round(((totalIncidents - highSeverityIncidents) / totalIncidents) * 100)
    : 100;

  let daysSinceLastIncident = 'N/A';
  if (totalIncidents > 0) {
    const sortedIncidents = [...incidents].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    const lastIncidentDate = new Date(sortedIncidents[0].created_at);
    const today = new Date();
    const diffTime = Math.abs(today - lastIncidentDate);
    daysSinceLastIncident = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  }

  return (
      <div className="space-y-6">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 sm:p-6">
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 dark:text-white mb-4 sm:mb-6">
                  Safety Dashboard
              </h3>
              {isLoading && incidents.length === 0 ? (
                  <div className="flex items-center justify-center py-8">
                      <p className="text-gray-500">Loading dashboard data...</p>
                  </div>
              ) : (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
                      <div className="bg-gray-50 dark:bg-gray-700 p-4 sm:p-5 rounded-lg border border-gray-100 dark:border-gray-600">
                          <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mb-2">Total Incidents</p>
                          <p className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-white">{totalIncidents}</p>
                      </div>
                      <div className="bg-gray-50 dark:bg-gray-700 p-4 sm:p-5 rounded-lg border border-gray-100 dark:border-gray-600">
                          <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mb-2">Open Incidents</p>
                          <p className="text-xl sm:text-2xl font-bold text-orange-600 dark:text-orange-400">{openIncidents}</p>
                      </div>
                      <div className="bg-gray-50 dark:bg-gray-700 p-4 sm:p-5 rounded-lg border border-gray-100 dark:border-gray-600">
                          <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mb-2">Safety Score</p>
                          <p className="text-xl sm:text-2xl font-bold text-green-600 dark:text-green-400">{safetyScore}%</p>
                      </div>
                      <div className="bg-gray-50 dark:bg-gray-700 p-4 sm:p-5 rounded-lg border border-gray-100 dark:border-gray-600">
                          <p className="text-xs sm:text-sm text-gray-600 dark:text-gray-400 mb-2">Days Since Last Incident</p>
                          <p className="text-xl sm:text-2xl font-bold text-blue-600 dark:text-blue-400">{daysSinceLastIncident}</p>
                      </div>
                  </div>
              )}
          </div>
      </div>
  );
};

export default DashboardTab;
